import http from "../http/http-config";
import { Locality } from "../models/Locality";

export default new class localityService {
    getLocalityList(queryTerm: string): Promise<Locality[]> {
        return http.get<Locality[]>("Localities", {
            params: {
                queryTerm
            }
        }).then(response => response.data)
    }
}

